// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"624441a2","824":"bd77c0d9","997":"ad6e88ae"}[chunkId] + ".chunk.js";
};